import { Outlet } from '@tanstack/react-router';
import { MenuHeader } from '@client/components/menu/menu-header.tsx';
import { Footer } from '@client/components/footer/footer.tsx';
import { useContext, type FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { ChangelogLoginModal } from '@r/components/changelogs/changelog-login-modal.tsx';
import { WorkspaceConfigContext } from '@r/context/workspace-config-context.ts';
import { useTranslation } from 'react-i18next';

const MainLayout: FC = () => {
  const { t } = useTranslation();
  const workspaceConfig = useContext(WorkspaceConfigContext);
  const pageDescription =
    workspaceConfig?.groupedConfigs?.core?.description || t('app.description');

  return (
    <>
      <Helmet>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <div className="flex flex-col min-h-screen">
        <MenuHeader />

        <div className="flex flex-col flex-grow">
          <Outlet />
        </div>

        <Footer />
      </div>

      <ChangelogLoginModal />
    </>
  );
};

export default MainLayout;
